var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QuotationSelectedCompany',{attrs:{"form":_vm.readonlyForm},on:{"return":_vm.previousStep}}),_c('QuotationInsuredForm',{attrs:{"options-quotation":_vm.optionsQuotation},on:{"submit":_vm.submit,"cancel":_vm.cancelQuotationButton},model:{value:(_vm.formInsured),callback:function ($$v) {_vm.formInsured=$$v},expression:"formInsured"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }